import trim from 'lodash-es/trim';
export const isMissingOrWhitespace = (text: string) => text === null || trim(text) === '';
